<div class="container-table">
  <div class="zit-scrollbar table-rows-container table">
    <table mat-table [dataSource]="tableData.payload">
      <ng-container matColumnDef="statusDate">
        <th mat-header-cell *matHeaderCellDef>Дата и время</th>
        <td mat-cell *matCellDef="let element">
          <div class="field-content">
            <span class="date">{{ element.statusDate | date: 'dd.MM.yyyy HH:mm' : undefined : 'ru' }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="statusName">
        <th mat-header-cell *matHeaderCellDef>Статус</th>
        <td mat-cell *matCellDef="let element">
          <div class="field-content status">
            <mat-icon *ngIf="element.statusCode" [class]="getUserStatusIcon(element.statusCode)"></mat-icon>
            <span>{{ getStatusName(element.statusCode) }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="reasonInfo">
        <th mat-header-cell *matHeaderCellDef>Причина</th>
        <td mat-cell *matCellDef="let element">
          <div class="field-content">
            <span>{{ element?.reasonInfo }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="authorRoleName">
        <th mat-header-cell *matHeaderCellDef>Роль</th>
        <td mat-cell *matCellDef="let element">
          <div class="field-content">
            <span>{{ getActiveLang() === 'ru' ? element.authorRoleRu : element.authorRoleEn }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="authorName">
        <th mat-header-cell *matHeaderCellDef>Пользователь</th>
        <td mat-cell *matCellDef="let element">
          <div class="field-content">
            <span>{{ element?.authorName }}</span>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
